// extracted by mini-css-extract-plugin
export default {"outer":"HomePage__outer___YC9pP","toggle_menu":"HomePage__toggle_menu___RwB71","no_table":"HomePage__no_table___vA1vN"};